import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartFulfillmentMethodStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = mergeToNew(
    cartFulfillmentMethodStyles.fulfillmentMethodradioGroup,
    {
        labelProps: {
            color: "text.accent",
        },
    },
);

cartFulfillmentMethodStyles.pickUpLocation = mergeToNew(cartFulfillmentMethodStyles.pickUpLocation, {
    headerText: {
        color: "text.accent",
    },
});
